import { MainColor } from '../../palette/colors';

export const getDrawerDetailsThemeConfig = () => {
  return {
    default: {
      background: 'white95' satisfies MainColor as MainColor,
      border: 'coolGrey10' satisfies MainColor as MainColor,
      borderAlt: 'coolGrey30' satisfies MainColor as MainColor,
      title: 'navy95' satisfies MainColor as MainColor,
      label: 'coolGrey60' satisfies MainColor as MainColor,
      text: 'navy95' satisfies MainColor as MainColor,
      detailBackground: 'coolGrey5' satisfies MainColor as MainColor,
      link: 'forest50' satisfies MainColor as MainColor,
      error: {
        border: 'red20' satisfies MainColor as MainColor,
        borderFormError: 'red40' satisfies MainColor as MainColor,
        background: 'red10' satisfies MainColor as MainColor,
      },
    },
  };
};
export type DrawerDetailsTheme = ReturnType<typeof getDrawerDetailsThemeConfig>;
